import { useState } from "react";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";

import { COLOR } from "../../styles/colors";

import { AccordionItem } from ".";
import MinusIcon from "./MinusIcon.svg";
import PlusIcon from "./PlusIcon.svg";
import Styled from "./index.styles";

export default function Item({
  data,
  usesDivider,
}: {
  data: AccordionItem;
  usesDivider?: boolean;
}) {
  const { isMobile } = useCheckIsMobile();

  const [opens, setOpens] = useState(false);

  const iconSize = isMobile ? 20 : 24;

  return (
    <Styled.item
      className={`${data.className ? data.className : ""} accordion-item`}
      opens={opens}
      usesDivider={usesDivider}
    >
      <div className="title" onClick={() => setOpens(!opens)}>
        {opens ? (
          <MinusIcon
            className="icon"
            width={iconSize}
            height={iconSize}
            color={COLOR.grayScale_900}
          />
        ) : (
          <PlusIcon
            className="icon"
            width={iconSize}
            height={iconSize}
            color={COLOR.grayScale_600}
          />
        )}

        <div className="text">{data.title}</div>
      </div>

      {opens && <div className="desc">{data.desc}</div>}
    </Styled.item>
  );
}
